module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/root-zh-hant-ebeaab25bb7a1b2c9de502832478f29b.svg";